import React from 'react';
import { Modal } from 'ui';
import SeismicContentPicker from 'components/shared/SeismicContentPicker';

const UniversalPickerModal = ({
  requestUpdateAndApplyChanges,
  closeModal,
  setIsLoading,
}) => {
  const documentPicked = items => {
    if (items.length === 1) {
      const {
        repository,
        name,
        libraryContent: { id, teamsiteId },
        applicationUrls: [{ url }],
        profileVersionId,
      } = items[0];
      const updateParams = {
        repository,
        name,
        library_content_id: id,
        library_content_teamsite_id: teamsiteId,
        universal_link: url,
        profile_version_id: profileVersionId,
      };
      setIsLoading(true);
      closeModal();
      requestUpdateAndApplyChanges(updateParams).then(() =>
        setIsLoading(false),
      );
    }
  };

  return (
    <Modal
      className="SeismicContentModal"
      modalWrapperClassName="SeismicContentModal-background"
      shown
      enableFloatingDismiss
      onDismiss={closeModal}
      canClickAway={false}
    >
      <div className="SeismicContentModal-header">
        <div className="SeismicContentModal-header--title">
          {t('questions.types.content.modal.title')}
        </div>
      </div>
      <SeismicContentPicker
        pickerSettings={{
          assetTypeFilter: {
            filterType: 'blacklist',
            values: [
              'LiveDoc',
              'LiveDoc Component',
              'Email Template',
              'Article',
            ],
          },
        }}
        documentPicked={documentPicked}
      />
    </Modal>
  );
};

export default UniversalPickerModal;
